import {
  HStack,
  VStack,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Alert,
  CloseButton,
} from "@chakra-ui/react";
import React from "react";
import { MarkdocContent } from "../../../../../markdoc/MarkdocContent";
import { ContactSupport } from "../../../../molecules/ContactSupport";

export function DataSourceErrorSection({
  errorDetails: { message, title },
  context: {
    dataSource: { name },
  },
  onClose,
  primaryActionButton,
}: {
  errorDetails: { title: string; message?: string };
  context: { dataSource: { name: string } };
  onClose?: React.Dispatch<void>;
  primaryActionButton?: React.ReactNode;
}) {
  return (
    <Alert
      status="error"
      flexDirection="row"
      alignItems="flex-start"
      borderRadius="md"
      borderWidth="1px"
      borderColor="red.500"
      w="full"
    >
      <AlertIcon />
      <VStack w="full" alignItems="flex-start" spacing={4}>
        <VStack w="full" alignItems="flex-start" spacing={1}>
          <AlertTitle>{title}</AlertTitle>
          {message && (
            <AlertDescription>
              <MarkdocContent content={message} />
            </AlertDescription>
          )}
        </VStack>

        <HStack>
          {primaryActionButton}
          <ContactSupport
            variant="link"
            colorScheme="red"
            supportPrompt={`I had an error syncing my ${name} data source`}
          />
        </HStack>
      </VStack>
      {onClose && (
        <CloseButton
          alignSelf="flex-start"
          position="relative"
          right={-1}
          top={-1}
          onClick={() => onClose()}
        />
      )}
    </Alert>
  );
}
